import { render } from "./checkway.vue?vue&type=template&id=5bd054e8&scoped=true&ts=true"
import script from "./checkway.vue?vue&type=script&lang=ts"
export * from "./checkway.vue?vue&type=script&lang=ts"

import "./checkway.vue?vue&type=style&index=0&id=5bd054e8&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd054e8"]])

export default __exports__